import {__STAGING__} from '~/utils/env';

export const getHeaders = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
};

export const postHeaders = {
  method: 'post',
  credentials: 'same-origin',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
};

// sends credentials cross origin when requesting rfe on staging
export const rfeCredentialsHeader = __STAGING__ ? 'include' : 'same-origin';

export function checkResponseOkay(response, shouldReturnErrorMessage = false) {
  if (response.ok) {
    return response;
  } else {
    if (shouldReturnErrorMessage) {
      return response.json().then(errorMessage => Promise.reject(errorMessage));
    } else {
      return Promise.reject(response);
    }
  }
}
